import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { MenuItem, Select, Switch, Input } from '@material-ui/core';
import { patchVariable } from '../../Containers/VariableServer/service/actions';
import './style.scss';

const DEFAULT_VALUES = {
	checkbox: false,
	string: '',
	number: 0,
	select: '',
};

const isChecked = value => value === true || value === '1' || value === 'true';

class InputVariableServer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { inputValue: props.value };
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({ inputValue: this.props.value });
		}
	}

	patch = value => {
		this.props.patch({ key: this.props.keyVariable, value });
	};

	onInputChange = e => {
		this.setState({ inputValue: e.target.value });
	};

	onInputValid = () => {
		if (this.state.inputValue !== this.props.value) {
			this.patch(this.state.inputValue);
		}
	};

	onInputKeyPress = e => {
		if (e.key === 'Enter') {
			e.target.blur();
		}
	};

	renderInput() {
		const { type, options, value, disabled } = this.props;

		switch (type) {
			case 'checkbox':
				return (
					<Switch
						checked={isChecked(value)}
						disabled={disabled}
						onChange={e => this.patch(e.target.checked ? '1' : '0')}
					/>
				);
			case 'select':
				return (
					<Select
						className="input-variable-server-select"
						value={value}
						disabled={disabled}
						onChange={e => this.patch(e.target.value)}
					>
						{options.map(option => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				);
			default:
				return (
					<Input
						value={this.state.inputValue}
						type={type === 'number' ? 'number' : 'text'}
						disabled={disabled}
						onChange={this.onInputChange}
						onBlur={this.onInputValid}
						onKeyPress={this.onInputKeyPress}
					/>
				);
		}
	}

	render() {
		return (
			<div className="input-variable-server-container">
				<span className="input-variable-server-label">
					{I18n.t(`partner.variable.${this.props.keyVariable}`)}
				</span>
				<div className="input-variable-server-input">{this.renderInput()}</div>
			</div>
		);
	}
}

InputVariableServer.propTypes = {
	keyVariable: PropTypes.string.isRequired,
	type: PropTypes.oneOf(['checkbox', 'string', 'number', 'select']),
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string,
		})
	),
	defaut: PropTypes.any,
	disabled: PropTypes.bool,
};

InputVariableServer.defaultProps = {
	type: 'string',
	options: [],
};

const mapStateToProps = (state, props) => {
	const type = props.type || 'string';
	const variable = Object.values(state.variableServer).find(
		v => v.key_ === props.keyVariable
	);
	const defaut =
		props.defaut !== undefined ? props.defaut : DEFAULT_VALUES[type];

	return {
		value: variable ? variable.value : defaut,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		patch: bindActionCreators(patchVariable, dispatch),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InputVariableServer);
